import React from 'react';
import TelemedIcon from 'components/atoms/icons/telemedIcon';
import path from 'constants/paths';
import PropTypes from 'prop-types';

const MenuItemTelemed = ({ onClick }) => (
  <div className="menu-item-icon">
    <div className="menu-item-icon__icon">
      <TelemedIcon />
    </div>
    <a
      href={path.telmed}
      target="_blank"
      onClick={onClick}
      className="menu-item-icon__link"
    >
      <div className="menu-item-icon__text">Telemed</div>
    </a>
  </div>
);

MenuItemTelemed.defaultProps = {
  onClick: () => {},
};

MenuItemTelemed.propTypes = {
  onClick: PropTypes.func,
};

export default MenuItemTelemed;
